import { Box, Container, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SecondaryButton } from '../../components/GetStarted/GetStarted';
import { ReactComponent as HomeIcon } from '../../assets/icons/info/home.svg';
import { ReactComponent as NotFoundIcon } from '../../assets/errorPage/notFound.svg';
import { GlassColors } from '../../components/glassmorphism/GlassmorphismStyles';

export const NotFound: React.FC = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 295px)',
        background: isDark ? '#1A1A1A' : '#E5E5DC',
        paddingTop: { xs: '80px', sm: '120px' },
        paddingBottom: { xs: '24px', sm: '60px' },
      }}
    >
      <Container
        maxWidth='lg'
        sx={{
          width: '956px',
          maxWidth: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: { xs: '24px', sm: '48px' },
        }}
      >
        <Box
          sx={{
            position: 'relative',
          }}
        >
          <Box
            sx={{
              py: { xs: '26px', tablet: '120px' },
              backdropFilter: { xs: 'blur(2px)', sm: 'blur(3px)' },
              position: 'relative',
              zIndex: 1,
            }}
          >
            <Typography
              component='h1'
              sx={{
                fontFamily: 'Montserrat, sans-serif',
                fontWeight: { xs: 600, sm: 500 },
                fontSize: { xs: '34px', sm: '60px' },

                color: isDark ? GlassColors.accent : GlassColors.secondary,
                lineHeight: { xs: '124%', sm: '120%' },
                letterSpacing: { xs: '0.25px', sm: '-.5px' },
                marginBottom: { xs: '16px', sm: '16px' },
                textAlign: 'center',
              }}
            >
              Page not found
            </Typography>
            <Typography
              component='h4'
              sx={{
                fontFamily: 'Roboto, sans-serif',
                fontSize: { xs: 14, sm: 16 },
                fontWeight: 700,
                letterSpacing: { xs: '.1px', sm: '.15px' },
                lineHeight: { xs: '157%', sm: '175%' },
                mb: '16px',
                color: isDark
                  ? GlassColors.dark.textPrimary
                  : GlassColors.light.textPrimary,
                textAlign: 'center',
              }}
            >
              Sorry, we couldn’t find the page you’re looking for. It might have
              been removed, renamed, or doesn’t exist.
            </Typography>

            <SecondaryButton
              onClick={() => {
                navigate('/');
              }}
              sx={{
                fontFamily: '"Montserrat", sans-serif',
                color: '#fff',
                fontSize: { xs: 14, sm: 16 },
                lineHeight: { xs: '32px', sm: '32px' },
                height: { xs: '40px', sm: '48px' },
                minWidth: { xs: '182px' },
                padding: '8px 24px',
                width: 'auto',
                borderRadius: '24px',
                border: 0,
                m: 'auto',
                backgroundColor: isDark
                  ? GlassColors.dark.iconBtnBackground
                  : GlassColors.light.iconBtnBackground,

                '& svg': {
                  width: { xs: '20px', sm: '24px' },
                },
              }}
            >
              <HomeIcon />
              Go to Homepage
            </SecondaryButton>
          </Box>
          <Box
            sx={{
              position: 'absolute',
              width: '100%',
              textAlign: 'center',
              left: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              p: '0 10px',
              '& svg': {
                maxWidth: '100%',
                '& path': {
                  fill: isDark
                    ? GlassColors.dark.primaryBackground
                    : GlassColors.light.primaryBackground,
                },
              },
            }}
          >
            <NotFoundIcon />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
